export default "__VITE_ASSET__CYkCHRii__"